// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import vueMoment from 'vue-moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import vSelect from 'vue-select';
import * as svgicon from 'vue-svgicon';
import VModal from 'vue-js-modal';
import Meta from 'vue-meta';
import Circle2 from '@common/components/Spinner';
import Stretch from '@common/components/Stretch';
import { ModelListSelect } from 'vue-search-select';
import PortalVue from 'portal-vue';
import Vuelidate from 'vuelidate';
import Sticky from 'vue-sticky-directive';
import VueProgress from 'vue-progress-path';
// import 'vue-progress-path/dist/vue-progress-path.css';
import infiniteScroll from 'vue-infinite-scroll';
import vClickOutside from 'v-click-outside';
import VueSessionStorage from 'vue-sessionstorage';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import * as VueGL from 'vue-gl';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import infiniteLoading from 'vue-infinite-loading';
// eslint-disable-next-line import/no-extraneous-dependencies
import pandoConstants from 'pando-constants';
import Multiselect from 'vue-multiselect';
import VueAnalytics from 'vue-analytics';
import Hotjar from 'vue-hotjar';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import 'firebase/messaging';

import OrderConstants from '@common/constants/orderConstants';

import numberIndianFormat from '@common/utils/numberIndianFormat';
import amountToWords from '@common/utils/amountToWords';
import APP_CONSTANTS from '@common/utils/constants';
import Ellipsis from '@common/components/Ellipsis';
import menuOptionsUtils from '@common/utils/menuOptions';
import WordList from '@common/components/WordList';
import numberCurrencyFormat from '@common/utils/numberCurrencyFormat';
import Tab from '@/components/common/tabs/Tab';
import Tabs from '@/components/common/tabs/Tabs';
import PrimaryFilter from './components/common/Filter';
import './element';
import App from './App';
import router from './router';
import store from './store';
import depot from './utils/depot';
import invoice from './utils/invoicing';
import title from './utils/title';
import features from './utils/features';
import permissionUtils, { hasPermissions, hasCustomFieldPermission, hasDashboardPermission } from './utils/permission';
import ga from './utils/ga';
import isRole from './utils/role';
import mdmUtils from './utils/mdm';
import Permission from './directives/permission';
import numericOnly from './directives/numericValue';
import validateString from './directives/validateString';


import i18n from './i18n';
import translate from './utils/localisation-translation';
import WebSocketPrinter from './utils/websocket-printer';
import { autoLogout, autoLogOutTimeSet } from '@common/helpers/auto-logout';


async function loadingVueJs(data, logoInfo) {
  Vue.config.productionTip = false;
  /** Decryption */
  const appSecret = window.location.origin.replace(/\/|http:|https:/gi, () => ''); // To extract the domain_url
  const bytes = CryptoJS.AES.decrypt(data, appSecret);
  const apiData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  await store.commit('app/ENVIRONMENT_DATA', apiData);
  await store.commit('app/UPDATE_LOGO', logoInfo);
  const datepickerOptions = {
    colors: {
      selected: '#0076DD',
      inRange: '#D9E6FF',
      selectedText: '#404040',
      text: '#404040',
      disabled: '#fff',
    },
  };

  Vue.config.productionTip = false;
  Permission.install();

  Vue.use(VueAnalytics, {
    id: apiData.ga_key,
    router,
    debug: {
      enabled: false,
      sendHitTask: Boolean(apiData.ga_key),
    },
  });
  if (apiData.hj_s_id) {
    Vue.use(Hotjar, {
      id: apiData.hj_s_id, // Hotjar Site ID
      isProduction: Boolean(apiData.hj_s_id),
    });
  }
  Vue.use(AirbnbStyleDatepicker, datepickerOptions);
  Vue.use(VueGoogleMaps, {
    load: {
      key: apiData.gm_key,
      libraries: 'places',
      installComponents: true,
    },
  });
  Vue.use(VueSessionStorage);
  Vue.use(APP_CONSTANTS);
  Object.keys(VueGL).forEach((name) => {
    Vue.component(name, VueGL[name]);
  });

  Vue.use(VueProgress, {
    defaultShape: 'circle',
  });
  Vue.use(Sticky);
  Vue.use(svgicon, { tagName: 'svgicon' });
  Vue.use(vueMoment, { moment });
  Vue.use(VModal);
  Vue.use(infiniteLoading);
  Vue.use(Meta);
  Vue.use(PortalVue);
  Vue.use(Vuelidate);
  Vue.use(infiniteScroll);
  Vue.use(vClickOutside);
  Vue.directive('numericOnly', numericOnly);

  Vue.component('v-select', vSelect);
  Vue.component('Tabs', Tabs);
  Vue.component('Tab', Tab);
  Vue.component('Ellipsis', Ellipsis);
  Vue.component('WordList', WordList);
  Vue.component('Spinner', Circle2);
  Vue.component('Processing', Stretch);
  Vue.component('ListSelect', ModelListSelect);
  Vue.component('PrimaryFilter', PrimaryFilter);
  Vue.component('multiselect', Multiselect);
  Vue.component('GmapCluster', GmapCluster);

  // const options = {
  //   namespace: 'tsm__', // key prefix
  //   storage: 'local', // storage name session, local, memory
  // };


  // Vue.use(Storage, options);
  Vue.prototype.$pandoConstants = pandoConstants;
  Vue.prototype.$orderConstants = OrderConstants;
  Vue.prototype.$depot = depot;
  Vue.prototype.$invoice = invoice;
  Vue.prototype.$hasFeature = features;
  Vue.prototype.$title = title;
  Vue.prototype.$hasPermission = permissionUtils;
  Vue.prototype.$hasPermissions = hasPermissions;
  Vue.prototype.$hasDashboardPermission = hasDashboardPermission;
  Vue.prototype.$hasCustomFieldPermission = hasCustomFieldPermission;
  Vue.prototype.$addGAEvent = ga;
  Vue.prototype.$translate = translate;
  Vue.prototype.$checkMenuOptions = menuOptionsUtils;
  Vue.prototype.$isRole = isRole;
  Vue.prototype.$getIndianFormat = numberIndianFormat;
  Vue.prototype.$getCurrencyFormat = numberCurrencyFormat;
  Vue.prototype.$getWords = amountToWords;
  Vue.prototype.$getUpdatedByUserName = mdmUtils;
  Vue.prototype.$asset_path = process.env.VUE_APP_S3_PATH;
  Vue.prototype.$WebSocketPrinter = WebSocketPrinter;
  Vue.prototype.$window = window;
  Vue.prototype.$validateString = validateString;


  /* eslint-disable no-new */
  const el = '#app';
  new Vue({
    el, router, store, components: { App }, template: '<App/>', i18n,
  });
}

async function run() {
  const hostname = window.location.host;
  const isDevelopment = hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1');
  const baseURL = isDevelopment ? 'http://localhost:3000/api' : '/api';
  const axiosInstance = axios.create({ baseURL, timeout: 1800000 });
  let bootstrapResponse = '';
  let logoInfo = '';
  axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('tsm-user-token');
    const isLogin = window.location.pathname === '/login';
    if ((token && token !== 'undefined')) { //  && !isLogin) {
      config.headers = { Authorization: `bearer ${token}` }; // eslint-disable-line
    }
    return config;
  }, error => Promise.reject(error));

  axiosInstance.interceptors.response.use((response) => {
    const token = response.headers['x-auth-token'];
    bootstrapResponse = response.headers['ui-session'];
    logoInfo = (response.data && response.data.logo_buffer) || '';
    if (token) {
      localStorage.setItem('tsm-user-token', token);
    }
    autoLogOutTimeSet(response.status);
    return (response.data) ? response.data : response;
  }, error => Promise.reject(error.response));
  await axiosInstance.get('ui-bootstrap');
  autoLogout(store);
  loadingVueJs(bootstrapResponse, logoInfo);
}


run();
